import { render, staticRenderFns } from "./copyfictitiousmeter.vue?vue&type=template&id=4db50ab3&"
import script from "./copyfictitiousmeter.vue?vue&type=script&lang=ts&"
export * from "./copyfictitiousmeter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copyfictitiousmeter.vue"
export default component.exports